<template>
  <div>
    <div class="d-flex flex-column justify-end">
      <div class="d-flex mt-1 mb-1" v-for="item in items" :key="item.id">
        <div class="mr-2">
          <StyledKeyword style="font-size: 12px; color: #dfe2ea; background-color: #9155fd; min-width: 144px">
            <div class="d-flex align-end">
              <VCustomIcon :size="18" name="coin-stack_5949896" class="mr-1"></VCustomIcon>
              <p class="ma-0 pa-0" style="min-width: 40px">
                {{ item.minAmount | krw }}
              </p>
              <p class="ma-0 px-1 py-0">~</p>
              <p class="ma-0 pa-0" style="min-width: 40px">
                {{ item.maxAmount | krw }}
              </p>
            </div>
          </StyledKeyword>
        </div>

        <InstructionSelector
          :filterTags="['도네이션', '사용자정의']"
          :value="item.reactionId"
          @change="$emit('changeItem', item.id, $event)"
          @play="$emit('play', $event)"
          dense
          hide-details
        ></InstructionSelector>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // [{ id, minAmount, maxAmount, reactionId }]
    items: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    krw(value) {
      if (value === null || value === undefined) return "     "; // maxAmount null = 무제한
      const temp = value.toLocaleString("ko-KR");
      return `${temp}원`;
    },
  },
};
</script>

<style></style>
